import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const BookingRequest = {
  // Fetch filtered list of bookings based on parameters
  bookingFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getBookingFilterSet}`, {
      withCredentials: true,
      params: {
        fromCity: values?.fromCity,
        toCity: values?.toCity,
        bookingStatusId: values?.bookingStatusId,
        bookingTypeId: values?.bookingTypeId,
        tripId: values?.tripId,
        passengerPhone: values?.passengerPhone,
        isActive: values?.isActive,
      },
    }),

  // Fetch a single booking by ID
  getBookingById: (bookingId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getBookingById}/${bookingId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),

  // Create a new booking
  createBooking: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createBooking}`, values, {
      withCredentials: true,
    }),

  // Activate or deactivate a booking
  activeInactiveBooking: (values) =>
    api.put(`${API_URL.BASEURL}${API_URL.activeInactiveBooking}`, values, {
      withCredentials: true,
    }),

  // Upload an image for the booking
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");

    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=staff`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  },

  // Update an existing booking by ID
  updateBooking: (bookingId, values) =>
    api.put(
      `${API_URL.BASEURL}${API_URL.updateBooking}/${bookingId}`, // Send ID directly in the URL
      values,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json", // Ensure that the request body is being treated as JSON
        },
      }
    ),
};

export default BookingRequest;
